<template>
  <section
    id="menu"
    class=""
    :class="{ visible: this.$store.state.menu_is_visible }"
  >
    <div
      v-for="(item, index) in menu"
      class="item"
      :class="{ selected: item.url === path, disabled: item.disabled }"
    >
      <router-link :to="item.url" @click.self="select(item)">
        <img class="img" :src="item.img" />
        <div class="content">
          <span class="name">{{ item.name }}</span>
          <span v-if="item.description" class="description">{{
            item.description
          }}</span>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        {
          url: "/partner/reports",
          name: "Google MyBusiness",
          description: this.$t('partner.layout.menu_description'),
          selected: true,
          img: "/img/national.svg"
        }
      ]
    };
  },
  computed: {
    userType() {
      return this.$store.getters["user/getType"];
    },
    path() {
      return this.$route.path;
    }
  },
  methods: {
    select(item) {
      if (!item.disabled) {
        for (var k in this.menu) {
          this.menu[k].selected = false;
        }
        item.selected = true;
        this.$store.commit("setMenuVisible", false);
        //this.$store.commit('setSearch', '');
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#menu {
  width: 100%;
  background: #222;
  border-bottom: 2px solid var(--main_color);
  padding: 10px 20px;
  position: relative;
  overflow: hidden;
  display: none;

  &.visible {
    display: block;
  }
  .item {
    width: 25%;
    padding: 6px;
    float: left;
    height: 80px;
    text-decoration: none;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);

      .img {
      }
    }
    &.selected {
      .content {
        .name {
          color: var(--main_color);
        }
      }
    }
    .img {
      width: 40px;
      height: 40px;
      display: inline-block;
      float: left;
      margin-top: 10px;
    }
    .content {
      display: inline-block;
      width: calc(100% - 40px);
      padding: 10px;
      text-align: left;
      .name {
        font-weight: bold;
        color: var(--dark_color);
        font-size: 13pt;
        color: #eee;
      }
      .description {
        display: block;
        font-size: 9.5pt;
        color: #777;
      }
      .disabled {
        display: block;
        font-size: 9.5pt;
        color: #777;
      }
    }
    .search {
      margin-top: -5px;
    }
  }
}
</style>
